import React, { useState, useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { StatusBar } from "@capacitor/status-bar";
import { useUser } from "reactfire";
import { applyTheme } from "../utils/theme";
import { createTheme } from "../utils/theme";
import { themes, ConvertRGBtoHex } from "utils/utils";
import { useTranslation } from "react-i18next";
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";

const GameContext = React.createContext();

function gameReducer(state, action) {
  switch (action.type) {
    case "setInvitedToLeagueId": {
      let id = action.value.id;
      let lms = action.value.gameType === 1;
      return { ...state, invitedToLeagueId: id, invitedToLeagueTypeIsLms: lms };
    }
    case "setEditLeagueId": {
      return { ...state, editLeagueId: action.value };
    }
    case "setPremium": {
      let isActive = action.value.isActive;
      let expirationDate = action.value.expires;
      return { ...state, premium: isActive, premiumExpires: expirationDate };
    }
    case "setHideBottomBar": {
      return { ...state, hideBottomBar: action.value };
    }
    case "setEventModalEvent": {
      return {
        ...state,
        eventModalEvent: action.value.event,
      };
    }
    case "setTheme": {
      FirebaseAnalytics.logEvent({
        name: "change_theme",
        params: {
          content_type: "theme",
          content_id: action.value,
        },
      });
      return { ...state, theme: action.value };
    }

    case "setGameUsers": {
      return { ...state, gameUsers: action.value };
    }

    case "setLeagues": {
      return { ...state, leagues: action.value };
    }

    case "setGameList": {
      return { ...state, gameList: action.value };
    }
    case "setUserGameData": {
      return { ...state, userGameData: action.value, isLoading: false };
    }

    case "setUserMessages": {
      return { ...state, messages: action.value };
    }

    case "setSettings": {
      let settingsData = {};
      if (action.value && action.value.length == 1) {
        settingsData = action.value[0];
      } else return;

      return { ...state, settings: settingsData };
    }

    case "resetContext": {
      return {
        settings: {},
        premium: false,
        premiumExpires: null,
        userGameData: null,
        invitedToLeagueId: null,
        invitedToLeagueTypeIsLms: false,
        editLeagueId: null,
        gameUsers: [],
        messages: [],
        leagues: [],

        isLoading: true,
        eventModalEvent: null,
        hideBottomBar: false,
        theme: themes[4],
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function GameProvider({ children }) {
  const { status, data: user } = useUser();
  const { t } = useTranslation();

  const [state, dispatch] = React.useReducer(gameReducer, {
    settings: {},
    premium: false,
    premiumExpires: null,
    userGameData: null,
    invitedToLeagueId: null,
    invitedToLeagueTypeIsLms: false,
    editLeagueId: null,
    gameUsers: [],
    messages: [],
    leagues: [],
    gameList: [],
    isLoading: true,
    eventModalEvent: null,
    hideBottomBar: false,
    theme: useState(() => {
      const localData = window.localStorage.getItem("theme");
      return localData ? JSON.parse(localData) : themes[4];
    })[0],
  });

  useEffect(() => {
    const appliedTheme = createTheme(state.theme);

    applyTheme(appliedTheme);

    let rgbColor = state.theme.headerPrimary.split(" ");
    let hex = ConvertRGBtoHex(rgbColor[0], rgbColor[1], rgbColor[2], "b3");
    if (Capacitor.getPlatform() === "android" && hex) {
      StatusBar.setBackgroundColor({
        color: hex,
      });
    }
  }, [state.theme]);
  /*
  useEffect(() => {
    if (!state.userGameData) return;
    let userTheme = themes[state.userGameData.theme];
    if (userTheme) {
      window.sessionStorage.setItem("theme", JSON.stringify(userTheme));
      state.theme = userTheme;
    }
  }, [state.userGameData]); */

  const value = { state, dispatch };
  return <GameContext.Provider value={value}>{children}</GameContext.Provider>;
}

function useGame() {
  const context = React.useContext(GameContext);
  if (context === undefined) {
    throw new Error("useEvent must be used within a EventProvider");
  }
  return context;
}

export { GameProvider, useGame };
